import { CATEGORY_CONFIG, MAX_WIDTH_BAR } from './constants';
import { EfficiencyCategory } from './types';

export function colorByCategory(category: EfficiencyCategory): string {
  const color = CATEGORY_CONFIG[category].color ?? 'none';

  return color;
}

export function responsiveWidthBarByCategory(category: EfficiencyCategory): string {
  return `${(CATEGORY_CONFIG[category].width / MAX_WIDTH_BAR) * 76}%`;
}
